import styled from "styled-components";
import React from "react";
import { useSelector } from "react-redux";

const RegularButton = styled.button`
  font-size: 1em;
  font-weight: 600;
  border: 1px solid ${(props) => props.theme.color.blue};
  border-radius: 6px;
  cursor: pointer;
  color: white;
  display: inline-block;
  background: ${(props) => props.theme.color.blue};
  text-transform: none;
  padding: 1.1em 1em;
  transition: background-color 0.25s;
  width: 224px;
  margin: 0 auto 2.125em;
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: none;
    background: ${(props) => props.theme.color.blue};
    color: #ffffff;
  }
`;

const GhostButton = styled(RegularButton)`
  border: 1px solid ${(props) => props.theme.color.gray};
  background: transparent;
  color: ${(props) => props.theme.color.medGray};
  &:hover,
  &:focus {
    background: transparent;
    color: ${(props) => props.theme.color.medGray};
  }
`;

const BackButton = styled(RegularButton)`
  content: "";
  border-radius: 50%;
  background: ${(props) => props.theme.color.black};
  border: 1px solid ${(props) => props.theme.color.black};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  position: absolute;
  left: 1em;
  top: 1em;
  width: 38px;
  height: 38px;
  transition: all 0.1s linear;
  transform: scale(1);
  &:hover,
  &:focus {
    transform: scale(1.1);
    background: ${(props) => props.theme.color.black};
  }
  & img {
    transition: all 1ms linear;
    transform: scale(1);
  }
`;

const ArrowIcon = styled.img`
  width: 18px;
  height: 14px;
`;

export default function Button({ disabled, back, ...rest }) {
  const showSpinner = useSelector((state) => state.showSpinner.value);

  if (back) {
    return (
      <BackButton {...rest}>
        <ArrowIcon alt="" src="/static/images/iconArrow-Left.svg" />
      </BackButton>
    );
  }
  if (disabled || showSpinner) {
    return <GhostButton disabled {...rest}></GhostButton>;
  }
  return <RegularButton {...rest}></RegularButton>;
}
